import * as React from 'react';
import { Field } from 'redux-form';
import { compose, withHandlers } from 'recompose';
import { default as RenderToggle } from 'material-ui/Toggle';
import { formWrapper } from '@inqool/uas-web-core/es/components/controls/reduxFormWrappers';

import * as T from '@components/form/Toggle/_toggleTypes';

const enhance = compose<T.InnerProps, T.OutterProps>(
  withHandlers({
    onToggle: ({ formChange, onToggle, name }) => (foo, val) => {
      if (!!formChange) {
        formChange(name, val);
      } else {
        onToggle(foo, val);
      }
    }
  })
);

const Toggle: React.SFC<T.OutterProps & T.InnerProps> = ({ errorText, ...props }) => {
  return <RenderToggle toggled={!!props.value} {...props} />;
};

export default formWrapper(enhance(Toggle));

export class ToggleField extends Field<T.OutterCustomProps> {}



// WEBPACK FOOTER //
// ./src/components/form/Toggle/Toggle.tsx